import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { getPageInfo, APP_NAME } from "../constants/pageInfo";

const PageTitle = ({appName = "report"}) => {
  const pageInfo = getPageInfo(appName);
  const location = useLocation();
  const pathname = location.pathname;

  // pathとマッチルールに基づいてタイトルを取得
  const page = pageInfo.find(({ path, match }) => {
    if (match === "exact") {
      return path === pathname;
    }
    if (match === "startsWith") {
      return pathname.startsWith(path);
    }
    return false;
  });

  const title = page ? `${page.title} - ${APP_NAME}` : APP_NAME;

  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
};

export default PageTitle;
